module.exports = __webpack_public_path__ + "img/elevance-health.1c27ff47.jpg";